<template>

  <div class="download-progress">
    <div
      class="download-progress__bar"
      :style="{transform: `translateX(-${translate}%)`}"
    >
      <div
        class="blank-space"
        :style="{background: `linear-gradient(90deg, #73BEE7 0%, #051E36 100%)`, opacity: opacity}"
      >
        <div></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PcDownloadProgress',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
   translate() {
      return 100 - this.progress
    },
    opacity(){
     return 0.2 + (1-(100-this.progress)/100) * 0.8
    }
  }
}
</script>

<style scoped lang="scss">
.download-progress {
  will-change: transform;
  z-index: 0;
  width: 86px;
  position: relative;
  height: 6px;
  min-width: 86px;
  overflow: hidden;
  border-radius: 3px;
  margin-top: 6px;

  &:after{
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background: #e5e5e5;
    top: 2px;
    z-index: 1;
  }

  &__bar {
    width: 100%;
    height: 100%;
    text-decoration: unset !important;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    background: #ffffff;
  }

  .blank-space {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
    z-index: 1;
    border-radius: 3px;
  }
  span {
    position: relative;
    z-index: 2;
  }
}
</style>
